var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LookupValue } from "../lookups/lookup.models";
var GetMyPurchasesResponse = /** @class */ (function () {
    function GetMyPurchasesResponse() {
        this.items = [];
    }
    return GetMyPurchasesResponse;
}());
export { GetMyPurchasesResponse };
var GetAgentWinningClaimsResponse = /** @class */ (function () {
    function GetAgentWinningClaimsResponse() {
        this.items = [];
    }
    return GetAgentWinningClaimsResponse;
}());
export { GetAgentWinningClaimsResponse };
var AgentWinningPayoutStatusModel = /** @class */ (function (_super) {
    __extends(AgentWinningPayoutStatusModel, _super);
    function AgentWinningPayoutStatusModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AgentWinningPayoutStatusModel;
}(LookupValue));
export { AgentWinningPayoutStatusModel };
var AgentWinningClaimsModel = /** @class */ (function () {
    function AgentWinningClaimsModel() {
    }
    return AgentWinningClaimsModel;
}());
export { AgentWinningClaimsModel };
var PurchasedItemModel = /** @class */ (function () {
    function PurchasedItemModel() {
    }
    return PurchasedItemModel;
}());
export { PurchasedItemModel };
var PurchasedTicketModel = /** @class */ (function () {
    function PurchasedTicketModel() {
    }
    return PurchasedTicketModel;
}());
export { PurchasedTicketModel };
var GetInstantGameUserPlayInfoResponse = /** @class */ (function () {
    function GetInstantGameUserPlayInfoResponse() {
    }
    return GetInstantGameUserPlayInfoResponse;
}());
export { GetInstantGameUserPlayInfoResponse };
var InstantGameUserPlayInfoViewModel = /** @class */ (function () {
    function InstantGameUserPlayInfoViewModel() {
    }
    return InstantGameUserPlayInfoViewModel;
}());
export { InstantGameUserPlayInfoViewModel };
var InstantGameClientModel = /** @class */ (function () {
    function InstantGameClientModel() {
    }
    return InstantGameClientModel;
}());
export { InstantGameClientModel };
var LotteryClientModel = /** @class */ (function () {
    function LotteryClientModel() {
    }
    LotteryClientModel.fromLobbyLottery = function (x) {
        return {
            closingDateTime: x.closingDateTime,
            countryId: x.countryId,
            currencySymbol: x.currencySymbol,
            drawDate: x.drawDate,
            drawMaximumNumber: x.drawMaximumNumber,
            drawMinimumNumber: x.drawMinimumNumber,
            drawTime: x.drawTime,
            drawnBonusMaximumNumber: x.drawnBonusMaximumNumber,
            drawnBonusMinimumNumber: x.drawnBonusMinimumNumber,
            drawnBonusNumbers: x.drawnBonusNumbers,
            drawnNumbers: x.drawnNumbers,
            friday: x.friday,
            isCustom: x.isCustom,
            isDrawDateCalculated: x.isDrawDateCalculated,
            lotteryId: x.lotteryId,
            lotteryName: x.lotteryName,
            monday: x.monday,
            saturday: x.saturday,
            sunday: x.saturday,
            thursday: x.thursday,
            totalJackpot: x.totalJackpot,
            totalJackpotInEuro: x.totalJackpotInEuro,
            tuesday: x.tuesday,
            wednesday: x.wednesday,
            ticketSalesClosingTime: x.ticketSalesClosingTime,
            isFonb: x.isFonb
        };
    };
    return LotteryClientModel;
}());
export { LotteryClientModel };
var LotteryTags = /** @class */ (function () {
    function LotteryTags() {
    }
    LotteryTags.getTags = function () {
        return [
            this.getName(this.HighestJackpot),
            this.getName(this.SecondHighestJackpot),
            this.getName(this.ThirdHighestJackpot),
            this.getName(this.NextClosingLottery)
        ];
    };
    LotteryTags.getName = function (str) {
        var result = str.replace(/-/g, " ");
        return result[0].toUpperCase() + result.substring(1).toLowerCase();
    };
    LotteryTags.HighestJackpot = "highest-jackpot";
    LotteryTags.SecondHighestJackpot = "second-highest-jackpot";
    LotteryTags.ThirdHighestJackpot = "third-highest-jackpot";
    LotteryTags.NextClosingLottery = "next-closing-lottery";
    return LotteryTags;
}());
export { LotteryTags };
var SystemEvents = /** @class */ (function () {
    function SystemEvents() {
    }
    SystemEvents.externalLogin = "externalLogin";
    return SystemEvents;
}());
export { SystemEvents };
var IFramePostMessages = /** @class */ (function () {
    function IFramePostMessages() {
    }
    IFramePostMessages.onOverlayVisibilityChange = "onOverlayVisibilityChange";
    IFramePostMessages.onIFrameHeightChange = "onIFrameHeightChange";
    IFramePostMessages.onIFrameRequestFullscreen = "onIFrameRequestFullscreen";
    IFramePostMessages.onCartCountChange = "onCartCountChange";
    IFramePostMessages.onScroll = "onScroll";
    IFramePostMessages.reloadPage = "reloadPage";
    IFramePostMessages.navigate = "navigate";
    IFramePostMessages.onScreenChange = "onScreenChange";
    IFramePostMessages.onResize = "onResize";
    IFramePostMessages.onInstantGameClose = "onInstantGameClose";
    IFramePostMessages.authenticated = "authenticated";
    IFramePostMessages.currentlyLockedPreview = "currentlyLockedPreview";
    return IFramePostMessages;
}());
export { IFramePostMessages };
